import { gql } from "@apollo/client";

import { SubmitSurveyInput } from "../../domain/survey/survey.types";

export interface SubmitSurveyOptions {
  variables: {
    survey_id: string;
    user: SubmitSurveyInput;
    lang: string;
  };
}

export interface AnswerQuestionOptions {
  variables: {
    survey_id: string;
    question_id: string;
    answer_id: string;
    isFirstAnswer: boolean;
  };
}

export interface GetSurveysByProjectOptions {
  variables: {
    project_id: string;
  };
}

export interface GetQuestionsBySurveyOptions {
  variables: {
    survey_id: string;
  };
}

const ANSWER_QUESTION_DATA = `
  done
  message
  details{
    id
    done
    message
  }
`;

const SUBMIT_SURVEY_DATA = `
  id
  firstName
  lastName
  email
  user
`;

const GET_SURVEYS_BY_PROJECT_DATA = `
  id
  name
  description
  project_id
  views
  starts
  completed
  completionPercentage
  completion_time
  logo
  image
  state
  createdBy
  tag
  startOn
  expiryOn
  createdOn
  updatedOn
`;

const GET_QUESTIONS_BY_SURVEY_DATA = `
  id
  questionType
  disposition
  title
  subtitle
  description
  defaultAnswer
  survey_ids
  answers {
    id
    value
    label
    type
    placeholder
    minLength
    maxLength
    question_id{
      id
    }
    deleted
    nextQuestion
    image
    order
    }
  fromTemplate
  nextQuestion
  regex
  section
  order
  disabled
  required
  additionalInfoKey
  image
  labels
  tags
  textButton
  minAnswers
  maxAnswers
  layout
  link
`;

export const GET_SURVEYS_BY_PROJECT = gql`
  mutation getSurveysByProject($project_id :ID!) {
    getSurveysByProject(project_id: $project_id) {
      ${GET_SURVEYS_BY_PROJECT_DATA}
      }
  }
`;

export const GET_SURVEYS_BY_PROJECT_OPTIONS = (project_id: string) => {
  const options: GetSurveysByProjectOptions = {
    variables: {
      project_id,
    },
  };
  return options;
};

export const GET_QUESTIONS_BY_SURVEY = gql`
  mutation getSurveysByProject($survey_id :ID!) {
    getSurveysByProject(survey_id: $survey_id) {
      ${GET_QUESTIONS_BY_SURVEY_DATA}
      }
  }
`;

export const GET_QUESTIONS_BY_SURVEY_DATA_OPTIONS = (survey_id: string) => {
  const options: GetQuestionsBySurveyOptions = {
    variables: {
      survey_id,
    },
  };
  return options;
};

export const SUBMIT_SURVEY = gql`
  mutation submitSurvey($survey_id :ID!, $user: SubmitSurveyInput!, $lang: String!) {
    submitSurvey(survey_id: $survey_id, user: $user, lang: $lang) {
      ${SUBMIT_SURVEY_DATA}
      }
  }
`;

export const SUBMIT_SURVEY_OPTIONS = (
  survey_id: string,
  user: SubmitSurveyInput,
  lang: string,
) => {
  const options: SubmitSurveyOptions = {
    variables: {
      survey_id,
      user,
      lang,
    },
  };
  return options;
};

export const ANSWER_QUESTION = gql`
  mutation answerQuestion($survey_id :ID!, $question_id :ID!, $answer_id :ID!, $isFirstAnswer : Boolean) {
    answerQuestion(survey_id: $survey_id, question_id: $question_id, answer_id: $answer_id, isFirstAnswer: $isFirstAnswer) {
      ${ANSWER_QUESTION_DATA}
      }
  }
`;

export const ANSWER_QUESTION_OPTIONS = (
  survey_id: string,
  answer_id: string,
  question_id: string,
  isFirstAnswer: boolean,
) => {
  const options: AnswerQuestionOptions = {
    variables: {
      survey_id,
      answer_id,
      question_id,
      isFirstAnswer,
    },
  };
  return options;
};

export default {
  ANSWER_QUESTION,
  SUBMIT_SURVEY,
  GET_QUESTIONS_BY_SURVEY,
  GET_SURVEYS_BY_PROJECT,
  GET_SURVEYS_BY_PROJECT_OPTIONS,
  GET_QUESTIONS_BY_SURVEY_DATA_OPTIONS,
  SUBMIT_SURVEY_OPTIONS,
  ANSWER_QUESTION_OPTIONS,
};
